import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { LoadingScreen } from '@/components/common/loading-spinner';

const CLIENT_MAP: Record<string, string> = {
  pinnacleforshopify: '8e760b4d84de29b76018581e4c0f2598',
  twilioforshopify: 'd17e3d73885c6dd7d3d61a4ab7d8ad84',
};

export function OAuthWosPage() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const stateParam = searchParams.get('state');
    const appCode = stateParam
      ? stateParam.split(':::')[1]
      : searchParams.get('appCode');

    if (!appCode) return;

    if (appCode.indexOf('shopify') > 0) {
      const shop = searchParams.get('shop');
      const code = searchParams.get('code');
      const clientId = searchParams.get('client_id');

      if (shop && !code) {
        const resolvedClientId = clientId || CLIENT_MAP[appCode] || '';
        const redirectUri = encodeURIComponent(
          `https://sms.ulgebra.com/oauth-home.html?appCode=${appCode}:::${resolvedClientId}`
        );
        const shopifyUrl =
          `https://${shop}/admin/oauth/authorize` +
          `?client_id=${resolvedClientId}` +
          `&scope=read_customers` +
          `&grant_options[]=offline` +
          `&redirect_uri=${redirectUri}` +
          `&state=isRedirect`;

        window.location.href = shopifyUrl;
      }
    }
  }, [searchParams]);

  return <LoadingScreen message="Authenticating..." />;
}
